import { useContext } from 'react';
import { PropertiesContext, PropertiesContextType } from '../context/PropertiesContextObject';

export const useProperties = (): PropertiesContextType => {
  const context = useContext(PropertiesContext);
  if (!context) {
    throw new Error('useProperties must be used within a PropertiesDataProvider');
  }
  return context;
};
